import React from "react";
import "./assistant.css";

import { Link, Outlet } from "react-router-dom";
import Sidebar from "../../Components/Sidebar";
import SidebarAssistant from "../../Components/SidebarAssistant";
import Navbar from "../../Components/Navbar";

const AssistantPage = ({ setIsAuth }) => {
  if (window.location.hostname === "localhost") {
    localStorage.setItem(
      "apiUrl2",
      "http://localhost/Git/Delsa/Accountant/"
      // "http://localhost/Saden/Frm"
    );
  } else {
    localStorage.setItem(
      "apiUrl2",
      // "http://localhost/Git/Delsa/Frm"
      "/Accountant"
    );
  }

  return (
    <div className="mainAssistant">
      <Navbar setIsAuth={setIsAuth} />
      <SidebarAssistant />
      <div className="main-assis-container">
        <Outlet />
      </div>
    </div>
  );
};

export default AssistantPage;
